import React from 'react';
import {useTranslation} from "react-i18next";

type SwitchWithTextProps = {
    checked: boolean
    onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
}

export const SwitchWithText: React.FC<SwitchWithTextProps> = ({checked, onChange}) => {
    const {t} = useTranslation();
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => onChange(event, event.target.checked);

    return (
        <label className="flex items-center relative cursor-pointer select-none ">
            <input type="checkbox" checked={checked} onChange={handleChange} className="peer bg-[#afb2c0] appearance-none transition-colors cursor-pointer w-[74px] h-[32px] max-tablet:w-[43px] max-tablet:h-[22px] rounded-full" />
            <span className="peer-checked:absolute peer-checked:w-full peer-checked:h-full peer-checked:rounded-full peer-checked:bg-[#03A9F4]"/>
            <span className="peer-checked:hidden absolute font-medium text-xs uppercase right-1 text-white max-tablet:hidden"> {t('switch.off')} </span>
            <span className="peer-checked:translate-x-[25px] tablet:peer-checked:translate-x-[41px] max-tablet:h-[12px] tablet:h-[24px] max-tablet:w-[12px] tablet:w-[24px] left-[4px] absolute rounded-full transform transition-transform bg-white" />
        </label>
    )
};
